import type { PublicApiKey } from '@/apilib';
import type { createAscendApi } from './ascendPublicApi';

export const AscendApiKey: PublicApiKey<typeof createAscendApi> = {
  name: 'AscendApi',
  public: true,
};
